import { PHONE_NO_REGEX } from 'global/appConstants';
import yup from 'utils/yup';

export const initialJobFormData = {
  id: '',
  name: '',
  job_code: '',
  description: '',
  street: '',
  users: [] as Array<any>,
  requireGeofence: [] as Array<any>,
  isPrimaryAddress: [] as Array<any>,
  rate: '',
  track_mileage: ['yes'] as Array<any>,
  radius: '100' as any,
  contactRequired: [] as Array<any>,
  contact_name: '',
  contact_phone: '',
  contact_mobile: '',
  contact_email: '',
  state: '',
  city: '',
  zip_code: '',
  country: '',
  on_arrival: '0',
  on_departure: '0',
  latitude: null,
  longitude: null,
  all_users: 0,
  geofenceMembers: [],
  group_ids: [],
  custom_geofence: '0',
  geofence_features: {} as GeoJSON.Feature<GeoJSON.Geometry, GeoJSON.GeoJsonProperties>,
  feature_collection: {} as any,
};

export const jobFormValidationSchema = yup.object().shape({
  name: yup.string().required(),
  rate: yup.number(),
  contact_email: yup.string().email(),
  contact_phone: yup.string().matches(PHONE_NO_REGEX, () => ({ msg: 'common:yup.default' })),
  contact_mobile: yup.string().matches(PHONE_NO_REGEX, () => ({ msg: 'common:yup.default' })),
});
